import { frontendURL } from '../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../featureFlags';

const SegmentsIndex = () => import('./pages/SegmentsIndex.vue');
const SegmentDetailPage = () => import('./pages/SegmentDetailPage.vue');
const ConversionsPage = () => import('./pages/ConversionsPage.vue');
const ConversionDetailPage = () => import('./pages/ConversionDetailPage.vue');

const commonMeta = {
  featureFlag: FEATURE_FLAGS.CRM,
  permissions: ['administrator', 'agent', 'segment_view'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/segments'),
    name: 'segments_index',
    component: SegmentsIndex,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/segments/:segmentId'),
    name: 'segment_detail',
    component: SegmentDetailPage,
    meta: commonMeta,
    props: true,
  },
  {
    path: frontendURL('accounts/:accountId/conversions'),
    name: 'conversions_index',
    component: ConversionsPage,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/conversions/:identifier'),
    name: 'conversion_detail',
    component: ConversionDetailPage,
    meta: commonMeta,
    props: true,
  },
];
